import { TextFieldWithLabel } from '../../../../Dispatch/RouteExecution/Pickups/PickupManagement/components/TextField';
import { MAX_DRIVER_COUNT, MIN_DRIVER_COUNT } from './utils';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  labelClass: {
    minWidth: 100
  },
  containerClass: {
    marginTop: 0,
    marginBottom: 0
  },
  inputClass: {
    width: 100
  }
});

const DayInputs = ({ classes, days, handleChange, driverPreferenceInfo, errorInfo }) => {
  return (
    <div>
      {days.map(({ field, label }) => (
        <TextFieldWithLabel
          key={field}
          id={field}
          handleChange={handleChange(field)}
          value={driverPreferenceInfo[field] ?? ''}
          error={errorInfo[field]}
          label={label}
          type="number"
          inputProps={{ max: MAX_DRIVER_COUNT, min: MIN_DRIVER_COUNT }}
          labelClass={classes.labelClass}
          containerClass={classes.containerClass}
          inputClass={classes.inputClass}
        />
      ))}
    </div>
  );
};

export default withStyles(styles)(DayInputs);
